import React, { useContext, useEffect, useRef, useState } from "react";
import useFeatureHook from "./useFeatureHook";
import "./style.scss";

import { OCLandInsightsContext } from "../../../hooks/context/OcLandInsightsContext";

import FeatureToolbar from "./FeatureToolbar";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import CornerRecordEditWidget from "../../custom/corner-record-edit-tools/CornerRecordEditWidget";

const FeatureWidget = ({ view, activeWidget, openPage,pageConfig }) => {
  const [visible, setVisible] = useState(true);
  const [value, setValue] = React.useState(0);

  const featureWidgetDiv = useRef(null);

  const {
    featureCount,
    selectedFeatureIndex,
    selectedFeatureType,
    // prevFeaturesArray,
    featuresArray,
    menuOptions,
    openLayerDict,
    setOpenLayerDict,
  } = useFeatureHook({ view, featureWidgetDiv, openPage });
  const ocLandInsightsDictionaryCtx: any = useContext(OCLandInsightsContext);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (activeWidget === "feature") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  let titleField:string
  Object.keys(menuOptions).forEach((option)=>{
    menuOptions[option].list.forEach(item=>{
      if(selectedFeatureIndex-1===item.index){
        titleField=item.fieldList[0]
      }
    })
  })

  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }

  return (
    <>
      <div style={style}>
      <FeatureToolbar view={view} menuOptions={menuOptions} featureCount={featureCount} featuresArray={featuresArray} selectedFeatureType={selectedFeatureType} selectedFeatureIndex={selectedFeatureIndex}openLayerDict={openLayerDict}setOpenLayerDict={setOpenLayerDict}></FeatureToolbar>
{featureCount && value?<Typography>{`${titleField}: ${featuresArray[selectedFeatureIndex-1]?.attributes[titleField]}`}</Typography>:""}
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
      <Tab label="details" {...a11yProps(0)} />
          {pageConfig?.toolbars?.featureWidget && featureCount?<Tab label="tools" {...a11yProps(1)} />:""}
        </Tabs>
        <br></br>
    <CustomTabPanel value={value} index={0}>
   <div ref={featureWidgetDiv}></div>
      </CustomTabPanel>
      {pageConfig?.toolbars?.featureWidget ?<CustomTabPanel value={value} index={1}>
        <Typography component='p'>If tools are available for this feature, it will display below</Typography>
      {pageConfig?.widgets?.cornerRecordEdit &&<CornerRecordEditWidget view={view} layerIds={ocLandInsightsDictionaryCtx.data}></CornerRecordEditWidget>}
      </CustomTabPanel>:""}
      
      </div>
    </>
  );
};



function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >

          {children}

    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default FeatureWidget;
